var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#3f0a35",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M566.2 604.5c0-49.4 24.5-93.2 62.1-119.6H349c-6.3 0-12.4-2.7-16.6-7.5-2.8-1.1-5-3.5-5.8-6.4-0.8-2.9-0.1-6.1 1.8-8.4h-0.1l24.9-92.9c5.7-15.7 20.7-26.1 37.4-26h224.3c16.7-0.1 31.7 10.3 37.4 26l25 92.9c11.4-2.8 23.2-4.3 35.5-4.3 14.6 0 28.8 2.2 42.1 6.2l-27.8-117c-14.4-49.6-60.5-83.2-112.1-81.8H386.4c-51.6-1.4-97.7 32.2-112.1 81.8L245.2 470c-31.5 12.3-53.7 40.8-58.1 74.3l-8.3 78.1c-0.9 35 20.9 66.6 54 78 8 29.7 35.6 49.8 66.4 48.3 27.8-0.9 53.1-16.4 66.4-40.9H609c-26.4-26.4-42.8-63-42.8-103.3z m-208.9 14.1c-9.3 7.6-21.1 11.6-33.2 11.2-12 0.3-23.7-3.6-33.1-11.2-5.1-9.1-8-19.3-8.3-29.7-0.3-11.2 4.2-22 12.3-29.8 9.4-7.6 21.2-11.5 33.2-11.2 12.1-0.4 23.8 3.6 33.2 11.2 8.2 7.7 12.7 18.5 12.4 29.7-3 11.2-8.7 21.4-16.5 29.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M808.9 644.2H625c-18.6 0-33.7-15.1-33.7-33.7s15.1-33.7 33.7-33.7h183.9c18.6 0 33.7 15.1 33.7 33.7s-15.1 33.7-33.7 33.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M716.9 736.2c-18.6 0-33.7-15.1-33.7-33.7v-184c0-18.6 15.1-33.7 33.7-33.7s33.7 15.1 33.7 33.7v183.9c0.1 18.7-15 33.8-33.7 33.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVehicles);
export default __webpack_public_path__ + "static/media/add-vehicles.9a389f5f1e44a57aba464287f6519255.svg";
export { ForwardRef as ReactComponent };